import { IconProps } from "@/common/contracts/icon.contracts";

export const StarOutline = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0117 20.9423C17.3802 21.1765 17.8361 20.8304 17.7391 20.3926L16.4104 14.4067L20.8329 10.3856C21.153 10.0904 20.9881 9.5305 20.5517 9.48978L14.7228 8.9706L12.4437 3.33086C12.2788 2.91348 11.7163 2.91348 11.5514 3.33086L9.27222 8.9706L3.44338 9.48978C3.01664 9.5305 2.84206 10.0904 3.17182 10.3856L7.59437 14.4067L6.26566 20.3926C6.16868 20.8304 6.62451 21.1765 6.99305 20.9423L11.9975 17.7662L17.0117 20.9423ZM11.9967 15.9901L8.25184 18.3668L9.24729 13.8823L5.83796 10.7824L10.3192 10.3833L11.9975 6.23026L13.6759 10.3833L18.1659 10.7832L14.7575 13.8823L15.7535 18.3698L11.9967 15.9901Z"
        fill="currentColor"
      />
    </svg>
  );
};
